import { Fragment, useEffect, useState } from 'react';
import Spinner from '../../../spinner/Spinner';
import './GridKeywordPickerArrowsV5.css';
import { useStateValue } from '../../../../StateProvider';

const GridKeywordPickerArrowsV5 = ({ gridData, onKeywordSelected, activeKeywordData, mapFullScreen, demoId }) => {
	const [ isLoading, setIsLoading ] = useState(true);
	const [ keywords, setKeywords ] = useState();
	const [ { mobileReportView }, dispatch ] = useStateValue();

	useEffect(
		() => {
			if (gridData) {
				let tempKeywords = [];
				gridData.data.forEach((keyword) => {
					tempKeywords.push({
						...keyword
					});
				});

				setKeywords(tempKeywords);
			} else {
				setKeywords([]);
			}
		},
		[ gridData ]
	);

	useEffect(
		() => {
			if (keywords) {
				setIsLoading(false);
			}
		},
		[ keywords ]
	);

	const handleKeywordClick = (keyword) => {
		if (onKeywordSelected) {
			onKeywordSelected(keyword);
		}
	};

	const handleChange = (e) => {
		const keyword = e.target.value;
		const selectedKeyword = keywords.find((k) => k.keyword === keyword);

		handleKeywordClick(selectedKeyword);
	};

	return (
		<div className={`grid-report-keywords-v5 container p-0 ${mapFullScreen ? 'is-full-screen' : ''}`}>
			{isLoading && <Spinner />}

			{!isLoading &&
			keywords &&
			keywords.length > 0 && (
				<Fragment>
					{mobileReportView ? (
						<select
							className="form-select w-100"
							onChange={handleChange}
							disabled={demoId ? 'disabled' : ''}
						>
							{keywords.map((keyword, index) => (
								<option key={index} value={keyword.keyword}>
									{keyword.keyword}
								</option>
							))}
						</select>
					) : (
						<ul className={`nav nav-pills ${demoId ? 'disabled' : ''}`}>
							{keywords.map((keyword, index) => (
								<li className="nav-item" key={index}>
									<button
										type="button"
										className={`nav-link ${activeKeywordData.keyword &&
										activeKeywordData.keyword === keyword.keyword
											? 'active'
											: ''}`}
										onClick={handleChange}
										value={keyword.keyword}
									>
										{keyword.keyword}
									</button>
								</li>
							))}
						</ul>
					)}
				</Fragment>
			)}
		</div>
	);
};

export default GridKeywordPickerArrowsV5;
